import { useState, useEffect } from 'react';
import api from '../api/axios';

const CACHE_KEY = 'browse_categories_cache';
const CACHE_TTL = 60 * 60 * 1000; // 1 hour in ms

const FALLBACK = {
    community: [
        { label: 'CSI Christian',   slug: 'csi-christian' },
        { label: 'Roman Catholic',  slug: 'roman-catholic' },
        { label: 'Pentecostal',     slug: 'pentecostal' },
        { label: 'Nadar Christian', slug: 'nadar-christian' },
        { label: 'Vellalar',        slug: 'vellalar' },
        { label: 'Mudaliar',        slug: 'mudaliar' },
        { label: 'Pillai',          slug: 'pillai' },
        { label: 'Anglo Indian',    slug: 'anglo-indian' },
    ],
    education: [
        { label: 'BE / B.Tech',     slug: 'be-b-tech' },
        { label: 'MBA',             slug: 'mba' },
        { label: 'MBBS / MD',       slug: 'mbbs-md' },
        { label: 'ME / M.Tech',     slug: 'me-m-tech' },
        { label: 'MCA',             slug: 'mca' },
        { label: 'BA / BSc / BCom', slug: 'ba-bsc-bcom' },
        { label: 'Diploma',         slug: 'diploma' },
        { label: 'PhD',             slug: 'phd' },
    ],
    location: [
        { label: 'Chennai',      slug: 'chennai' },
        { label: 'Coimbatore',   slug: 'coimbatore' },
        { label: 'Madurai',      slug: 'madurai' },
        { label: 'Tirunelveli',  slug: 'tirunelveli' },
        { label: 'Trichy',       slug: 'trichy' },
        { label: 'Salem',        slug: 'salem' },
        { label: 'Kanyakumari',  slug: 'kanyakumari' },
        { label: 'Abroad',       slug: 'abroad' },
    ],
    profession: [
        { label: 'Software Engineer',   slug: 'software-engineer' },
        { label: 'Doctor',              slug: 'doctor' },
        { label: 'Nurse',               slug: 'nurse' },
        { label: 'Teacher',             slug: 'teacher' },
        { label: 'IT Professional',     slug: 'it-professional' },
        { label: 'Business',            slug: 'business' },
        { label: 'Government Employee', slug: 'government-employee' },
        { label: 'Engineer',            slug: 'engineer' },
    ],
};

const readCache = () => {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        const { ts, data } = JSON.parse(raw);
        if (Date.now() - ts > CACHE_TTL) return null;
        return data;
    } catch {
        return null;
    }
};

const writeCache = (data) => {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data }));
    } catch {
        // localStorage quota exceeded — ignore
    }
};

const useBrowseCategories = () => {
    const [categories, setCategories] = useState(() => readCache() ?? FALLBACK);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Already have fresh cache — no fetch needed
        if (readCache()) return;

        let cancelled = false;
        setLoading(true);

        api.get('/browse/categories')
            .then(res => {
                if (cancelled) return;
                const data = res.data?.data;
                if (data) {
                    writeCache(data);
                    setCategories(data);
                }
            })
            .catch(() => {
                // API failed — FALLBACK already set as initial state
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => { cancelled = true; };
    }, []);

    return { categories, loading };
};

export default useBrowseCategories;
